export const enum PrefixTranslationsEnum {
  ASSIST = 'assist',
  ENGAGE = 'api.engage',
  VEEVALIDATE = 'assist.validation.veevalidate',
  CUSTOMFIELD = 'CUSTOMFIELD.',
  CFOPTION = 'CFOPTION.',
  ENTITY_FIELD = 'ENTITY_FIELD.',
  IMPORT_ACTION_TYPE = 'assist.importActionTypeOption.',
  DUEDATE_SEARCH_MODE = 'assist.dueDateSearchMode.',
  ACTIVITY = 'ACTIVITY.',
  REASON = 'TICKETACTIONREASON.',
  SCHEDULE = 'SCHEDULE.',
  SCREEN = 'SCREEN.',
  SKILL = 'SKILL.',
  SPACE = 'SKILLGROUP.',
  TICKETACTIONTYPE = 'TICKETACTIONTYPE.',
  TYPOLOGY = 'TICKETTYPOLOGY.',
  USERGROUP = 'USERGROUP.',
  PRODUCT = 'PRODUCT.',
  INTERACTION = 'INTERACTION.',
  INTERACTION_CHANNEL = 'INTERACTION_CHANNEL.',
  INTERACTION_TYPE = 'INTERACTION_TYPE.',
  EXTERNAL = 'EXTERNAL.',
  INTERACTION_STATUS = 'INTERACTION_STATUS.',
  TICKETSTATUS = 'TICKETSTATUS.',
  USERSTATE = 'USERSTATE.',
  EMERGENCY = 'EMERGENCY.',
  PRIORITY = 'PRIORITY.',
  SEARCH_CONFIG = 'SEARCH_CONFIG.',
  REPLY_TEMP = 'REPLYTEMP.',
}

export const enum SuffixTranslationsEnum {
  SHORT = '.SHORT',
  LABEL = '.LABEL',
  DESCR = '.DESCR',
}

export type i18nMessagesDTOV2 = {
  locale: string
  key: string
  message: string
}

export interface LocalizedMessagesV2Params {
  key: string
  'is-exact-key'?: boolean
  locale?: string
}

export type i18nTranslation = {
  [key: i18nMessagesDTOV2['key']]: i18nMessagesDTOV2['message']
}
